import React, {PureComponent} from 'react';
import styled from 'styled-components';

import Card from '../Card';
import Button from '../Button';
import VirtualizedList from '../VirtualizedList';
import Icon from '../Icon';

class VirtualizedGrid extends PureComponent {
  renderRow = (row, rowIndex, measure) => {
    const {columns, onCellClick, children} = this.props;

    return (
      <GridRow>
        {row.map((cell, columnIndex) => (
          <GridCell
            key={`${rowIndex}-${columnIndex}`}
            width={columns[columnIndex].width}
            onClick={onCellClick ? () => onCellClick(cell, rowIndex, columnIndex, columns[columnIndex]) : undefined}>
            {children(cell, rowIndex, columnIndex, columns[columnIndex], measure)}
          </GridCell>
        ))}
      </GridRow>
    );
  }

  renderTitleCell(column) {
    const {titles} = this.props;
    if (titles) {
      return titles(column);
    }
    else {
      return (<GridHeaderTitle title={column.title}>{column.title ? column.title : <>&nbsp;</>}</GridHeaderTitle>);
    }
  }

  render() {
    const {columns, data, onCellClick, children, overrideListReset = false, ...containerProps} = this.props;
    const containerWidth = columns.reduce((width, column) => width + column.width, 0);
    const isMeasurable = columns.reduce((value, column) => value || column.measurable, false);

    return (
      <Card {...containerProps}>
        <ScrollContainer>
          <Grid width={containerWidth}>
            <GridHeader>
              {columns.map(column => (
                <GridHeaderCell key={column.key} width={column.width}>
                  <GridHeaderTitleContainer>
                    {this.renderTitleCell(column)}
                    {false && (
                      <GridSort>
                        <Icon name="chevron-down" size="1em" />
                      </GridSort>
                    )}
                  </GridHeaderTitleContainer>
                </GridHeaderCell>
              ))}
            </GridHeader>
            <GridBody>
              <VirtualizedList
                style={{overflowX: 'hidden'}}
                measurable={isMeasurable}
                items={data}
                children={this.renderRow}
                overrideListReset={overrideListReset}
              />
            </GridBody>
          </Grid>
        </ScrollContainer>
      </Card>
    );
  }
}

const ScrollContainer = styled.div`
  width: 100%;
  height: 100%;
  overflow-x: auto;
`;

const Grid = styled.div`
  height: 100%;
  width: ${props => props.width}px;
  display: flex;
  flex-direction: column;
`;

const GridHeader = styled.div`
  box-shadow: 0 0 0.35rem rgba(0, 0, 0, 0.2);
  border-bottom: 0.0625rem solid #E1E5EB;
`;

const GridHeaderCell = styled.div`
  width: ${props => props.width}px;
  height: 3.125rem;
  display: inline-block;
  border-right: 0.0625rem solid #E1E5EB;

  :last-child {
    border-right: 0;
  }
`;

const GridHeaderTitleContainer = styled.div`
  display: flex;
`;

const GridHeaderTitle = styled.h4`
  margin: 0;
  padding: 1rem 0 0 1rem;
  flex: 1;
  white-space: nowrap; 
  overflow: hidden;
  text-overflow: ellipsis;
`;

const GridSort = styled.div`
  padding: 1rem;
`;

const GridBody = styled.div`
  flex: 1;
`;

const GridRow = styled.div`
  display: flex;
  transition: background 0.3s ease-in-out;

  :hover {
    background: #F5F5F8;
  }
`;

const GridCell = styled(props => props.onClick ? <Button block blank {...props} /> : <div {...props} />)`
  flex: 0 0 ${props => props.width}px;
  -ms-flex-preferred-size: calc(${props => props.width}px - 2rem - 1px);
  padding: 0.5rem 1rem;
  border-bottom: 0.0625rem solid #E1E5EB;
  border-right: 0.0625rem solid #E1E5EB;
  display: flex;
  align-items: center;
  line-height: 1.5;
  overflow-wrap: anywhere;
`;

export default VirtualizedGrid;